module.exports = __webpack_public_path__ + "h5/img/qingguanz@2x.8af62699.png";